<template>
  <div class="edit">
    <div class="edit-content">
      <div class="edit-item">
        <div class="title">限时提交<span> 开启后可设置限时提交</span></div>

        <el-switch
          v-model="editForm.limitSubmit"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="edit-item" v-if="editForm.limitSubmit == 1">
        <div class="title">以下条件二选一</div>
        <el-radio v-model="editForm.limitSubmitType" :label="1"
          >须提前</el-radio
        >
        <el-radio v-model="editForm.limitSubmitType" :label="2"
          >可补交</el-radio
        >
        <div class="edit-item-list" v-if="editForm.limitSubmitType == 1">
          <span>须提前 </span>
          <el-input-number
            v-model="editForm.limitSubmitValue"
            :min="1"
            :max="10"
            size="mini"
          ></el-input-number>
          <span> 天提交</span>
        </div>
        <div class="edit-item-list" v-if="editForm.limitSubmitType == 2">
          <span>须 </span>
          <el-input-number
            v-model="editForm.limitSubmitValue"
            :min="1"
            :max="10"
            size="mini"
          ></el-input-number>
          <span> 天后补卡提交</span>
        </div>
      </div>
      <div class="edit-item">
        <div class="title">
          参与打印
          <span>(如不勾选，打印时不显示该项)</span>
        </div>
        <el-switch v-model="editForm.pint" :active-value="1" :inactive-value="0"
          >参与打印
        </el-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    batchClick() {
      this.$emit("batchClick");
    },
    addSelect() {
      this.$emit("addSelect");
    },
    removeSelect() {
      this.$emit("removeSelect");
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;
  img {
    margin-right: 16px;
  }
}
.edit-none {
  height: 100%;
  color: #999999;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}
.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;
  .iconfont {
    margin-right: 8px;
  }
}
.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;
  div {
    line-height: 36px;
  }
}
.addedit {
  padding: 12px 0;
  color: #0f66f2;
  span {
    padding: 0 8px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}
.edit-item {
  margin-bottom: 16px;
  .title {
    margin-bottom: 12px;
    span {
      font-size: 12px;
      color: #999;
    }
    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}
.edit-item2 {
  margin-bottom: 12px;
}
.edit-have {
  height: 100%;
}
.edit-item-list {
  margin-bottom: 8px;
}
.edit-ul {
  width: 80%;
  margin: 16px auto;
  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;
    div {
      width: 50%;
      text-align: center;
      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
